// src/components/Login.js
import React, { useState } from 'react';
import { signIn, sendPasswordReset } from '../services/authService';

const Login = ({ onLoginSuccess, switchToRegister }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [resetEmailSent, setResetEmailSent] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Form validation
    if (!formData.email || !formData.password) {
      setError('Please enter both email and password');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      const result = await signIn(formData.email, formData.password);
      
      if (result.success) {
        onLoginSuccess(result.user);
      } else {
        setError(result.error || 'Login failed');
      }
    } catch (err) {
      setError(err.message || 'An error occurred during login');
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    if (!formData.email) {
      setError('Please enter your email address');
      return;
    }

    setResetLoading(true);
    setError('');
    
    try {
      const result = await sendPasswordReset(formData.email);
      if (result.success) {
        setResetEmailSent(true);
      } else {
        setError(result.error || 'Failed to send reset email');
      }
    } catch (err) {
      setError(err.message || 'An error occurred while sending reset email');
    } finally {
      setResetLoading(false);
    }
  };
  
  return (
    <div className="login-card">
      <div className="login-header">
        <div className="logo-container">
          📷
        </div>
        <h2>Equipment Booking System</h2>
        <p>Log in to book or manage equipment</p>
      </div>
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            name="email"
            type="email"
            placeholder="your.email@example.com"
            value={formData.email}
            onChange={handleChange}
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            name="password"
            type="password"
            placeholder="Enter your password"
            value={formData.password}
            onChange={handleChange}
          />
        </div>
        
        {error && <p className="error-message">{error}</p>}
        
        <button className="login-button animate-fade-in ripple-effect" type="submit" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>

        <div className="forgot-password" style={{ textAlign: 'center', marginTop: '0.5rem' }}>
          <button
            type="button"
            onClick={handleForgotPassword}
            disabled={resetLoading}
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--accent-color)',
              cursor: 'pointer',
              padding: 0,
              textDecoration: 'underline',
              fontSize: '0.9rem'
            }}
          >
            {resetLoading ? 'Sending...' : 'Forgot Password?'}
          </button>
          {resetEmailSent && (
            <p style={{ color: 'var(--success-color)', fontSize: '0.9rem', marginTop: '0.5rem' }}>
              Reset email sent! Please check your inbox.
            </p>
          )}
        </div>
        
        <div className="auth-link" style={{ textAlign: 'center', marginTop: '1rem' }}>
          <p>
            Don't have an account?{' '}
            <button 
              type="button" 
              onClick={switchToRegister}
              style={{ 
                background: 'none', 
                border: 'none', 
                color: 'var(--accent-color)', 
                cursor: 'pointer',
                padding: 0,
                textDecoration: 'underline'
              }}
            >
              Register
            </button>
          </p>
        </div>
      </form>
    </div>
  );
};

export default Login;